import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchResourceItem, updateResourceContribution, deleteResourceContribution, createResourceContribution, } from "../redux/actions";
import {
    userSelector, resourceSelector, dkpSelector, chapterSelector, resourceContributionSelector,
} from "../redux/selectors";
import { toArray } from '../common/util';
import ResourceContributionList from './ResourceContributionList';

class ResourceDetail extends Component {

    constructor(props) {
        super(props);
        this.newResourceControbution = this.newResourceContribution.bind(this);
        this.editResourceContribution = this.editResourceContribution.bind(this);
        this.delResourceContribution = this.delResourceContribution.bind(this);
    }

    componentDidMount() {
        document.title = "Addiction | DKP | " + this.props.match.params.id.toUpperCase() + " | History"
        this.props.getResourceItem(this.props.match.params.id)
    }

    newResourceContribution = (values) => {
        let newValues = {
            ...values,
            user: {
                slug: values.user
            }
        };
        this.props.submitNewResourceContribution(values.chapter.id, this.props.dkp.data[values.section].slug, values.slug, newValues)
    }

    editResourceContribution = (values) => {
        let newValues = {
            ...values,
            user: {
                slug: values.user
            }
        }
        this.props.submitEditResourceContribution(values.chapter, this.props.dkp.data[values.section].slug, values.resource.slug, values.id, newValues);
    };

    delResourceContribution = (data) => {
        this.props.submitDeleteResourceContribution(data.chapter, this.props.dkp.data[data.section].slug, this.props.resources.data[data.contrib.resource].slug, data.contrib.id)
    };

    render() {
        if (toArray(this.props.resources.data).filter((resource) => resource.slug === this.props.match.params.id).length > 0) {
            
            return (
                <div>
                    {toArray(this.props.resources.data)
                        .filter((resource) => resource.slug === this.props.match.params.id)
                        .map((resource, i) => (
                            <div key={`${i}-resource`}>
                                <h1>{resource.title}</h1>
                                <div className="panel-adt">
                                    <h2 className="text-primary">{resource.amount}</h2>
                                </div>
                                <ResourceContributionList section={this.props.dkp.data[resource.section]} resource={resource} newResourceContribution={this.newResourceContribution} editResourceContribution={this.editResourceContribution} delResourceContribution={this.delResourceContribution} />
                            </div>
                    ))}
                </div>
            )
        } else { return null }
    }
}

const mapStateToProps = (state) => ({
    users: userSelector(state),
    resources: resourceSelector(state),
    resourceContributions: resourceContributionSelector(state),
    dkp: dkpSelector(state),
    chapters: chapterSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    getResourceItem: (resource) => dispatch(fetchResourceItem(0,0,resource)),
    submitNewResourceContribution: (chapter, section, resource, data) => dispatch(createResourceContribution(chapter, section, resource, data)),
    submitEditResourceContribution: (chapter, section, resource, contribution, data) => dispatch(updateResourceContribution(chapter, section, resource, contribution, data)),
    submitDeleteResourceContribution: (chapter, section, resource, contribution) => dispatch(deleteResourceContribution(chapter, section, resource, contribution)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResourceDetail);


// WEBPACK FOOTER //
// ./src/Officer/ResourceDetail.js